import React from 'react';
import { Typography, Box, styled } from '@material-ui/core';

import { useWindowDimensions } from '@/hooks/useWindowDimensions';

const TitlesContainer = styled(Box)({
  '& > *': {
    marginBottom: 8,
  },
  marginBottom: 24,
});

interface TitlesProps {
  title: string,
  subtitle?: string,
}

export const Titles: React.FC<TitlesProps> = ({
  title,
  subtitle,
}) => {
  const { width } = useWindowDimensions();

  return (
    <TitlesContainer>
      <Typography variant={width > 600 ? 'h1' : 'h2'}>{title}</Typography>
      {subtitle && <Typography>{subtitle}</Typography>}
    </TitlesContainer>
  );
};
